export default "__VITE_ASSET__ad755e1f__"